// extracted by mini-css-extract-plugin
export default {"loader":"button_loader__FVPyR"};